import { useLazyQuery } from "@apollo/client";
import {
  getUserCommunicationNotification,
  getUserGeneralNotification,
  getUserVisionNotification,
} from "GraphQL/queries/profile";
import {
  allNotificationDataState,
  bellNotificationDetailSortedState,
  nextTokenState,
  notificationDetailSortedState,
  unReadCountState,
  visionNotificationDetailSortedState,
} from "Recoil/General/atom";
import { concat, get, orderBy, uniqBy } from "lodash";
import moment from "moment";
import { useRecoilState } from "recoil";
import {
  DATE_VALIDATION_FORMAT,
  FETCH_POLICY,
  NOTIFICATION_LIMIT,
} from "src/constants";
import { getUserId } from "src/utils";

export const headerNotifi = () => {
  const [notificationDetailSorted, setNotificationDetailSorted] =
    useRecoilState(notificationDetailSortedState);
  const [visionNotificationDetailSorted, setVisionNotificationDetailSorted] =
    useRecoilState(visionNotificationDetailSortedState);
  const [bellNotificationDetailSorted, setBellNotificationDetailSorted] =
    useRecoilState(bellNotificationDetailSortedState);
  const [allNotificationData, setAllNotificationData] = useRecoilState(
    allNotificationDataState
  );
  const [nextToken, setNextToken] = useRecoilState(nextTokenState);
  const [unReadCount, setUnReadCount] = useRecoilState(unReadCountState);
  const userId = getUserId();

  const notificationQueryVariables = {
    notificationFilter: {
      userId: { eq: userId },
      createdAt: {
        ge: moment().subtract(7, "d").format(DATE_VALIDATION_FORMAT),
      },
      isDeleted: { eq: false },
    },
    limit: NOTIFICATION_LIMIT,
  };
  const sortingDataForNotification = (data, type) => {
    const communicationNotify = [...notificationDetailSorted];
    const visionNotify = [...visionNotificationDetailSorted];
    const bellNotify = [...bellNotificationDetailSorted];

    const allData = concat(
      get(data, "listNotifications.items", []),
      allNotificationData
    );

    setAllNotificationData(uniqBy(allData, "id"));

    allData.map((res) => {
      if (res.isCommunicationNotification) {
        communicationNotify.push(res);
      } else if (res.isVisionNotification) {
        visionNotify.push(res);
      } else if (
        !res.isCommunicationNotification &&
        !res.isVisionNotification
      ) {
        bellNotify.push(res);
      }
      return res;
    });

    setNotificationDetailSorted(
      orderBy(uniqBy(communicationNotify, "id"), ["createdAt"], ["desc"])
    );
    setBellNotificationDetailSorted(
      orderBy(uniqBy(bellNotify, "id"), ["createdAt"], ["desc"])
    );
    setVisionNotificationDetailSorted(
      orderBy(uniqBy(visionNotify, "id"), ["createdAt"], ["desc"])
    );

    setNextToken({
      ...nextToken,
      [type]: get(data, "listNotifications.nextToken", ""),
    });
    setUnReadCount({
      ...unReadCount,
      [type]: get(data, "listNotifications.count", ""),
    });
  };

  const fetchData = () => {
    getGeneralData({
      variables: {
        ...notificationQueryVariables,
        type: "General",
      },
    });
    getUserData({
      variables: {
        ...notificationQueryVariables,
        type: "Communication",
      },
    });
    getVisionData({
      variables: {
        ...notificationQueryVariables,
        type: "Vision",
      },
    });
  };

  const [getUserData, { refetch, loading: communicationLoading }] =
    useLazyQuery(getUserCommunicationNotification, {
      ssr: false,
      fetchPolicy: FETCH_POLICY.networkOnly,
      nextFetchPolicy: FETCH_POLICY.cacheOnly,
      onCompleted: (data) => {
        sortingDataForNotification(data, "Communication");
      },
    });

  const [getVisionData, { loading: loadingVision }] = useLazyQuery(
    getUserVisionNotification,
    {
      ssr: false,
      fetchPolicy: FETCH_POLICY.networkOnly,
      nextFetchPolicy: FETCH_POLICY.cacheOnly,
      onCompleted: (data) => {
        sortingDataForNotification(data, "Vision");
      },
    }
  );

  const [getGeneralData, { loading: loadingGeneral }] = useLazyQuery(
    getUserGeneralNotification,
    {
      ssr: false,
      fetchPolicy: FETCH_POLICY.networkOnly,
      nextFetchPolicy: FETCH_POLICY.cacheOnly,
      onCompleted: (data) => {
        sortingDataForNotification(data, "General");
      },
    }
  );

  const nextLazyLoadVision = () => {
    if (nextToken["Vision"]) {
      setNextToken({ ...nextToken, ["Vision"]: null });
      getVisionData({
        variables: {
          ...notificationQueryVariables,
          nextToken: nextToken["Vision"],
          type: "Vision",
        },
      });
    }
  };

  const nextLazyLoadCommunication = () => {
    if (!communicationLoading && nextToken["Communication"]) {
      setNextToken({ ...nextToken, ["Communication"]: null });
      getUserData({
        variables: {
          ...notificationQueryVariables,
          nextToken: nextToken["Communication"],
          type: "Communication",
        },
      });
    }
  };

  const nextLazyLoadGeneral = () => {
    if (nextToken["General"]) {
      setNextToken({ ...nextToken, ["General"]: null });

      getGeneralData({
        variables: {
          ...notificationQueryVariables,
          nextToken: nextToken["General"],
          type: "General",
        },
      });
    }
  };

  return {
    getUserData,
    refetch,
    communicationLoading,
    getVisionData,
    loadingVision,
    getGeneralData,
    loadingGeneral,
    nextLazyLoadVision,
    nextLazyLoadCommunication,
    nextLazyLoadGeneral,
    fetchData
  };
};
